export const REGISTER_BUSINESS_URL = "/api/inquiry/register";
export const CONTACT_US_URL = "/api/inquiry/contactus"
export const DELETE_MY_ACCOUNT_REQ_OTP_URL = "/api/auth/delete/account/send-otp"
export const DELETE_MY_ACCOUNT_CONFIRM_URL = "/api/auth/delete/user"